import { Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular-ivy';
import { LostChangesReporter } from 'src/core/presence/domain/lost-changes-reporter';
import { LostChangesReport } from 'src/core/presence/domain/lost-changes-report';

/**
 * Sentry.init only enables sending in "dist" builds, so elsewhere this ends at the console.
 */
@Injectable({
  providedIn: 'any',
})
export class SentryLostChangesReporter extends LostChangesReporter {
  private static readonly MESSAGE = 'Pending changes lost on presence logout';
  // One issue for every occurrence
  private static readonly FINGERPRINT = ['presence-control-auto-logout-lost-changes'];

  report(report: LostChangesReport): void {
    const summary = report.summary();
    console.warn(summary);

    try {
      Sentry.captureMessage(SentryLostChangesReporter.MESSAGE, {
        level: 'warning',
        fingerprint: SentryLostChangesReporter.FINGERPRINT,
        tags: {
          rs_user_id: report.userId ?? 'unknown',
          rs_device_id: report.deviceId,
          rs_api_id: report.apiId,
          rs_trigger: report.trigger,
        },
        extra: {
          summary,
        },
      });
    } catch (error) {
      console.error('error while sending lost changes to Sentry:');
      console.error(error);
    }
  }
}
